import { render, staticRenderFns } from "./piles.vue?vue&type=template&id=176d646e&scoped=true&"
import script from "./piles.vue?vue&type=script&lang=js&"
export * from "./piles.vue?vue&type=script&lang=js&"
import style0 from "./piles.vue?vue&type=style&index=0&id=176d646e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d646e",
  null
  
)

export default component.exports